<button
  [ngClass]="[
    size === 'big' ? 'size-big' : 'size-small',
    textColor,
    buttonColor,
    nextIcon ? 'flex items-center gap-3' : '',
    fullWidth ? 'w-full' : '',
    'hero-button-enhanced'
  ]"
  class="transition-all duration-300 border rounded-full font-semibold"
>
  <span class="relative z-10">{{ buttonText }}</span>
  <img
    *ngIf="nextIcon"
    [src]="nextIcon"
    [alt]="'Ikona następnego elementu' | translate"
    class="button-icon w-4 h-4 lg:w-5 lg:h-5 relative z-10"
    [class.invert]="iconWhite"
  />
</button>
